import { useMemo } from "react"

import { getIn, useFormikContext } from "formik"
import * as Yup from 'yup'

import { FormikFileUpload, FormikNotesArea } from "../../../../../../components/widgets"

import {
  IDLMWebROIModel,
} from "../../../../../core/doclabel";

import { useDLMResponseFormContext } from "../../components";
import { DLMGenerateROIButton } from "../components"
import { DLMCreateROIButton } from "../../../widgets/DLMCreateROIButton"
import { IWebFileAttachment } from "../../../../../core/applications";

// Site Inspection
export interface IDLMPMRejectROI  {
  verdict: string
  workflow: string
  roiModels: Array<IDLMWebROIModel>
  note: string
  noteAttachments: Array<IWebFileAttachment>
}

export const initDLMPMRejectROIValues = {
  verdict: '',
  workflow: '',
  roiModels:[],
  note: '',
  noteAttachments: [],  
}

export const DLMPMRejectROISchema: any = Yup.object({
  appState: Yup.string().trim(),
  verdict: Yup.string().trim(),
  workflow: Yup.string().trim(),
  roiModels: Yup.array().label("ROI Attachments")
  .when('verdict', {
    is : (verdict: string) => (verdict === 'approved'),
    then: (schema) => schema.required().min(1, 'ROI Required').label("ROI Attachment").of(
      Yup.object().shape({
        roiId: Yup.number().label('ROI ID'),
        roiAttachmentId: Yup.number().label('ROI Attachment ID'),
        inspectionId: Yup.number().label('Inspection ID'),
        siteApplicationId: Yup.number().label('Site Application ID'),
        cocHolderRef: Yup.string().trim().label('CoC Holder Ref'),
        cocHolder: Yup.string().trim().label('CoC Holder'),
        cocHolderAddress: Yup.string().trim().label('CoC Holder Address'),
        installerCompany: Yup.string().trim().label('Installer Company'),
        cocNo: Yup.string().trim().label('cocNo'),
        brand: Yup.string().trim().label('brand'),
        model: Yup.string().trim().label('Model'),
        country: Yup.string().trim().label('Country'),
        projectName: Yup.string().trim().label('Project Name'),
        planNo: Yup.string().trim().label('Plan No'),
        inspector: Yup.string().trim().label('Inspector'),
        series: Yup.string().trim().label('Series'),
        no: Yup.number().label('No'),
        quantity: Yup.string().trim().label('Quantity'),
        serial: Yup.string().trim().label('Serial'),
        revision: Yup.number().label('Revision'),
        split: Yup.number().label('Split'),
        roiDetails: Yup.array().label('ROI Details'),
        getcbRef: Yup.string().trim().label('CB Reference'),
      })
    )
  }),
  note: Yup.string().trim().label('Note')
  .when('verdict', {
    is : (verdict: string) => (verdict !== 'approved'),
    then: (schema) => schema.required(),
  }),                
  noteAttachments: Yup.array(),
});

export const DLMProgramManagerRejectROIForm = () => {

  const { appID, siteID } = useDLMResponseFormContext();

  const { values, setFieldValue, validateField } = useFormikContext();

  const { verdict, roiModels } = useMemo(() => {
  if (! values) return { verdict: '', roiModels: []};

  const verdict = getIn(values, 'verdict');    
  const roiModels = getIn(values, 'roiModels');

  return { verdict, roiModels };

  }, [values]);

  const setROIModel = (values: any, idx: number) => {
    if (! (values && typeof(values) === 'object' && values?.roiId)) return;

    // clear attachment
    Object.assign(values, {
      roiAttachmentId: 0,
      roiAttachmentIdAttachmentName: ''
    });

    setFieldValue(`roiModels.${idx}`,values, true);
  }

  return (
  <>
  { (verdict === 'approved') &&
  <>
  <div className="d-flex flex-row justify-content-between align-items-center my-2">
    <div className="fs-6 fw-bold">Upload ROI</div>
    { (!roiModels?.length) && 
    <DLMCreateROIButton appID={appID} siteID={siteID} />        
    }    
  </div>    
  { (roiModels && roiModels.length > 0) && 
  <>
  <div className='separator border-gray-200 mb-2'></div>
  <div className="mh-250px overflow-auto pe-4">        {
    roiModels.map((roiModel: any, idx: number) => (
    <div key={`setROIrow_${idx}`} className="row mb-4">
      <div className="col-3">
        <DLMGenerateROIButton index={idx} onGenROI={setROIModel} baseData={roiModel} />
      </div>
      <FormikFileUpload
        size="9"
        label={`[${roiModel?.cbRef ? roiModel.cbRef : `${roiModel.series}${roiModel.no}${roiModel?.split ? roiModel?.split :''}`}] ${roiModel.projectName}`}
        name={`roiModels.${idx}.roiAttachmentId`}
        acceptFiles="UserFileFormats"
        required={true}
        disabled={(roiModel?.roiId) ? false : true}
        subTitle={(roiModel?.roiId) ? "Upload ROI here" : "Generate ROI first."}
        onUpdateFunc={() => {
          setTimeout(() => {
            validateField('roiModels');
          }, 100)
        }}
      />
    </div>
    ))
    }
  </div>    
  </>
  }
  </>
  }
  <div className='separator border-gray-200 my-2'></div>
  <FormikNotesArea required={verdict !== 'approved'} />
  </>
)
}